<template>
  <div class="instrumentTime">
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="院区">
          <el-select :disabled="areaDisabled" @input="testSX" v-model.trim="filters.areaCode" clearable placeholder="选择院区">
            <el-option v-for="(item,index) in areaOptions" :key="index" :label="item.areaName" :value="item.areaCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约时间">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" v-model="filters.appointmentTime" type="date" placeholder="选择日期时间" style="width: 90%" @change="editShowTime = false">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select v-model.trim="filters.projectType" clearable placeholder="选择需要查询的项目类型" @change="typeChange">
            <el-option v-for="(item,index) in projectTypeOptions" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-select @input="testSX" v-model.trim="filters.id" clearable placeholder="选择需要查询的项目名称" ref="myprojectName" @change="editShowTime=false" filterable remote :remote-method="(query)=>{projectMethod(query,filters.projectType)}" @focus="projectFocus">
            <el-option v-for="(item,index) in projectOptions" :key="index" :label="item.projectName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仪器名称">
          <el-select v-model.trim="filters.instrumentId" clearable placeholder="选择需要查询的仪器" filterable remote :remote-method="getName" @focus="instructionFocus" @change="editShowTime = false" ref="mySelected">
            <el-option v-for="(item,index) in options" :key="index" :label="item.instrumentName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="checkButton">
            <el-button type="primary" @click="query(1)">查询</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="editShowTime">
      <div class="appointTime">
        <div>
          <div class="appointTimeLong">
            <el-tag type="danger">当日已预约时间:</el-tag>
            <span v-for="(list,index) in editSuccessAppointTime.occupied" :key="index">
              <el-tag type="danger">{{list.instrumentDate}}</el-tag>
            </span>
          </div>
          <div class="appointTimeLong">
            <el-tag>当日可预约时间:</el-tag>
            <span v-for="(list,index) in editSuccessAppointTime.unoccupied" :key="index">
              <el-tag>{{list.instrumentDate}}</el-tag>
            </span>
          </div>
        </div>

      </div>
      <div>
        <el-divider content-position="left"><i class="el-icon-warning"></i> 预警次数</el-divider>
        <p v-for="(key,index) in msg.earlyWarning" :key="index">
          <span v-if="filters.areaCode==key.areaCode">{{key.startDateHms + '~' + key.endDateHms}} : {{key.warningNum}}次/每小时</span>
          <span v-if="filters.areaCode==''">{{key.startDateHms + '~' + key.endDateHms}} : {{key.warningNum}}次/每小时</span>
        </p>
        <el-divider content-position="left"><i class="el-icon-warning"></i> 项目累计次数说明</el-divider>
        <p>{{msg.remark}}</p>
      </div>

      <!--为echarts准备一个具备大小的容器dom-->
      <div id="main" style="width:100%;height: 400px;"></div>
    </div>

  </div>
</template>
<script>
import echarts from "echarts"
export default {
  name: "",
  data() {
    return {
      charts: "",
      filters: {
        instrumentName: '',
        appointmentTime: '',
      },
      projectTypeOptions: [{
        value: '1',
        label: '皮肤'
      }, {
        value: '2',
        label: '注射'
      }, {
        value: '3',
        label: '其他'
      }],
      options: [],
      editSuccessAppointTime: "",
      editShowTime: false,
      projectOptions: [],
      msg: "",
      echarts: '',
      areaOptions: [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }, {
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }],
      areaType: Lockr.get('areaType') == undefined || !Lockr.get('areaType') ? '' : Lockr.get('areaType'),
      areaDisabled: false,
      cityCode: Lockr.get('cityCode') == undefined || !Lockr.get('cityCode') ? '' : Lockr.get('cityCode'),
    }
  },
  created() {
    this.filters.areaCode = this.areaType
    if (this.areaType != '') {
      this.areaDisabled = true
    } else {
      this.areaDisabled = false
    }
  },
  methods: {
    testSX() {
      console.log('强制刷新')
      this.$forceUpdate()
    },
    typeChange() {
      this.filters.id = '';
      this.editShowTime = false
    },
    instructionFocus() {
      var querys = {
        instrumentNo: '',
        instrumentName: '',
        useDate: '',
        useMinute: '',
        page: 1,
        size: 999,
        startTime: '',
        endTime: '',
        cityCode: this.cityCode
      }
      api.request('/instrument/findInstrumentList', querys, (res) => {
        this.options = res.data.list
      }, (err) => { })
    },
    // 搜索查询全部可预约项目
    projectMethod(val, projectType) {
      let querys = {
        projectName: val,
        projectType: projectType,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
        this.$forceUpdate()
      }, (err) => { });
    },
    // 搜索查询全部可预约仪器
    getName(val) {
      var querys = {
        instrumentNo: '',
        instrumentName: val,
        useDate: '',
        useMinute: '',
        page: 1,
        size: 999,
        startTime: '',
        endTime: '',
        cityCode: this.cityCode
      }
      api.request('/instrument/findInstrumentList', querys, (res) => {
        this.options = res.data.list
      }, (err) => { })
    },
    // 编辑弹框查询项目
    projectFocus(val) {
      if (!this.filters.projectType) {
        _g.toast("warning", "请选择需要查询的项目类型!");
        return;
      }
      let querys = {
        projectName: "",
        projectType: this.filters.projectType,
        cityCode: this.cityCode
      };
      api.request("/project/findProjectListByName", querys, (res) => {
        // console.log(res)
        if (res.data.length == 0) {
          _g.toast("warning", "还没有可选择的项目!");
        }
        this.projectOptions = res.data;
      }, (err) => { });
    },
    drawLine(id, text, data, anchor, anchorNext) {
      this.charts = this.$echarts.init(document.getElementById(id))
      var anchor = [
        { name: anchor + '00:00:00', value: [anchor + '00:00:00', 0] },
        { name: anchorNext + '00:00:00', value: [anchorNext + '00:00:00', 0] }
      ];
      this.charts.setOption({
        title: {
          text: text
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            params = params[0];
            return (params.name.split(' ')[1]) + '~' + (parseInt(params.name.split(' ')[1].split(':')[0]) + 1 + ':00:00') + ' : ' + params.value[1];;
          },
          axisPointer: {
            animation: false
          }
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show: false
          },
          axisLine: {
            //y轴是否显示以及样式设置
            show: true,
          },
        },
        series: [{
          name: '模拟数据',
          type: 'line',
          showSymbol: false,
          hoverAnimation: false,
          data: data
        },
        {
          name: '.anchor',
          type: 'line',
          showSymbol: false,
          data: anchor,
          itemStyle: { normal: { opacity: 0 } },
          lineStyle: { normal: { opacity: 0 } }
        }]
      })
    },
    query() {
      if (!this.filters.appointmentTime) {
        _g.toast("warning", "请选择预约时间!");
        return;
      }
      if (!this.filters.instrumentId) {
        _g.toast("warning", "请选择需要查询的仪器名称!");
        return;
      }
      if (!this.filters.id) {
        _g.toast("warning", "请选择需要查询的项目名称!");
        return;
      }
      this.editShowTime = true

      // 根据预约门诊时间和仪器id提示仪器已预约时间
      let queryData = {
        appointmentTime: this.filters.appointmentTime,
        instrumentId: this.filters.instrumentId,
      }
      api.request("/appointment/findInstrumentDateById", queryData, (res) => {
        if (res.result == true) {
          let dataTimeAppoint = res.data
          this.editSuccessAppointTime = dataTimeAppoint
        }
      }, (err) => { });
      // 查询echarts数据
      let queryList = {
        projectType: this.filters.projectType,
        projectName: this.$refs.myprojectName.selected.label,
        appointmentTime: this.filters.appointmentTime,
        areaCode: this.filters.areaCode
      }
      api.request("/appointment/findAppointmentEchars", queryList, (res) => {
        this.msg = res.data
        // echarts图表字段
        var arr = []; //定义数组
        this.msg.echarts.forEach(list => {
          for (var i in list) {
            arr.push({
              name: i.split('/')[0],
              value: [i.split('/')[0], list[i]]
            });
          }
        });
        let nextDate = this.getNextDay(this.filters.appointmentTime.split(' ')[0])
        let timeName = this.filters.appointmentTime.split(' ')[0] + ' ' + this.msg.category
        this.drawLine("main", timeName, arr, this.filters.appointmentTime, nextDate)
      }, (err) => { });
    },
    getNextDay(d) {
      d = new Date(d);
      d = +d + 1000 * 60 * 60 * 24;
      d = new Date(d);
      //return d;
      //格式化
      return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    }
  },


}
</script>
<style scoped>
.checkButton >>> .el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}
.appointTimeLong {
  text-align: left;
  margin-left: 5%;
  width: 1200px;
}
.appointTimeLong >>> .el-tag {
  margin-bottom: 10px;
  margin-right: 10px;
}
.appointTime {
  display: flex;
  margin-bottom: 30px;
}
.instrumentTime >>> .el-divider__text {
  color: #f56c6c;
}
</style>